import { IFamily } from '@gn-audio/core/api/product-catalogue/models/family';
import { SegmentType } from '@gn-audio/core/common/enums';

import { ProductComparisonSegmentType, ProductComparisonSegmentTypeIndex } from "../models/product-comparison-segment-type";

const allConsumer = (segmentTypes: SegmentType[]): boolean => {
  return segmentTypes.every((s: SegmentType) => s === SegmentType.Consumer);
};

const allBusiness = (segmentTypes: SegmentType[]): boolean => {
  return segmentTypes.every((s: SegmentType) => s === SegmentType.Business || s === SegmentType.Convergence);
};

export const getComparisonSegmentType = (families: IFamily[]): ProductComparisonSegmentTypeIndex => {
  let segmentType: ProductComparisonSegmentTypeIndex = ProductComparisonSegmentType.Mixed;
  const familySegmentTypes: SegmentType[] = families.map((f: IFamily) => f.segmentType);

  if (allConsumer(familySegmentTypes)) {
    segmentType = ProductComparisonSegmentType.Consumer;
  } else if (allBusiness(familySegmentTypes)) {
    segmentType = ProductComparisonSegmentType.Business;
  }

  return segmentType;
};
